export * from './useCustomFonts';
export { inter as font } from './inter';
export { useFontsWebLoader } from './useFontsWebLoader';
